import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";
import * as navigationActions from "../../../actions/navigationActions";
import * as helperActions from "../../../actions/helperActions";
import * as keyboardActions from "../../../actions/virtualKeyboardActions";

import imgDelete from "../../../resources/img/svgicons/delete.svg";
import imgSend from "../../../resources/img/svgicons/send.svg";

import CustomIcon from "../CustomIcon";
import Input from "../generic/Input";
import CancelButton from "../generic/CancelButton";
import Button, {BUTTON_SMALL} from "../generic/Button";
import Modal from "../generic/Modal";

class BugReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            subject: "",
            content: "",
            filePaths: []
        };
    }

    componentDidMount() {
        if (this.props.redlikeLightSoftware) {
            window.jQuery("#bug-subject").on(
                "change",
                function (event) {
                    if (this.state.subject !== event.target.value) {
                        this.handleSubjectChange(event);
                    }
                }.bind(this)
            );
            window.jQuery("#bug-content").on(
                "change",
                function (event) {
                    if (this.state.content !== event.target.value) {
                        this.setState({
                            content: event.target.value
                        });
                    }
                }.bind(this)
            );
        }
    }

    componentWillUnmount() {
        if (this.props.redlikeLightSoftware) {
            window.jQuery("#bug-subject").unbind("change");
            window.jQuery("#bug-content").unbind("change");
        }
    }

    handleSubjectChange = (event) => {
        this.setState({
            subject: event.target.value
        });
    };

    handleSubjectFocus = () => {
        this.props.dispatchSetUniversalKeyboardStateAction(true, "bug-subject");
    };

    handleContentFocus = () => {
        this.props.dispatchSetUniversalKeyboardStateAction(true, "bug-content");
    };

    handleContentChange = (event) => {
        this.setState({
            content: event.target.value
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseBugReportModalAction();
    };

    handleSendButtonClick = () => {
        this.props.dispatchSendErrorReportAction(this.state.subject, this.formatMessage(), this.state.filePaths);
    };

    handleAddFileButtonClick = () => {
        windowService.openSelectFilesDialog(this.getFilesPathCallback);
    };

    handleRemoveFilePathClick = (event) => {
        let paths = [];
        for (let path of this.state.filePaths) {
            if (event.currentTarget.dataset.path !== path) {
                paths.push(path);
            }
        }

        this.setState({
            filePaths: paths
        });
    };

    getFilesPathCallback = (result) => {
        /* eslint-disable-next-line no-undef */
        let pathsSet = [...new Set(this.state.filePaths.concat(result.filePaths))];
        this.setState({
            filePaths: pathsSet
        });
    };

    formatMessage = () => {
        let formattedMessage = [];
        let textRows = this.state.content.split("\n");
        for (let row of textRows) {
            formattedMessage.push(row);
        }

        formattedMessage.push("");
        formattedMessage.push("Logs: ");
        formattedMessage.push("license: " + this.props.license);
        formattedMessage.push("posName: " + this.props.pos.name);
        formattedMessage.push("posStreet: " + this.props.pos.street);
        formattedMessage.push("posCountry: " + this.props.pos.country);
        formattedMessage.push("posRegion: " + this.props.pos.region);
        formattedMessage.push("posCity: " + this.props.pos.city);
        formattedMessage.push("posZip: " + this.props.pos.zip);
        formattedMessage.push("swVersion: " + this.props.swVersion);
        formattedMessage.push("mainDbVersion: " + this.props.mainDbVersion);
        formattedMessage.push("localDbVersion: " + this.props.localDbVersion);
        formattedMessage.push("");
        return formattedMessage.join("<br>");
    };

    getFilePathsSection = () => {
        return this.state.filePaths.reverse().map((path) => (
            <div className="col-12 flex flex-align-center-vertical flex-gap-10px" key={path}>
                <Button
                    size={BUTTON_SMALL}
                    className="svg-only-btn"
                    onClick={this.handleRemoveFilePathClick}
                    svgBefore={imgDelete}
                    elementProps={{
                        "data-path": path
                    }}
                />
                <div className="ellipsis">{path}</div>
            </div>
        ));
    };

    getAddFileSection = () => {
        if (windowService.isBrowser()) {
            return "";
        }

        return (
            <div
                className="col-12 flex flex-column flex-gap-10px"
                style={{
                    height: "30%"
                }}
            >
                <div>{translate("general.attachments")}:</div>
                <Button
                    size={BUTTON_SMALL}
                    className="margin-right-auto"
                    onClick={this.handleAddFileButtonClick}
                    label={translate("general.addFile")}
                />
                <div className="slim-scroll flex flex-column flex-child" style={{rowGap: "5px"}}>
                    {this.getFilePathsSection()}
                </div>
            </div>
        );
    };

    getLoader = () => {
        if (this.props.blocked) {
            return (
                <CustomIcon
                    iconType={componentTypes.ICON_LOADER}
                    className="loader margin-left-auto margin-right-auto"
                    alt="loading"
                />
            );
        }

        return "";
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex">
                    <div className="col-2">
                        <Translate value="helper.subject" />:
                    </div>
                    <Input
                        className="col-10 primary-input flex-child"
                        id="bug-subject"
                        value={this.state.subject}
                        onFocus={this.props.redlikeLightSoftware ? this.handleSubjectFocus : null}
                        onChange={this.handleSubjectChange}
                    />
                </div>
                <div className="col-12">
                    <Translate value="helper.content" />:
                </div>
                <textarea
                    id="bug-content"
                    className="primary-input slim-scroll col-12 flex-child fill-flex-space resize-none"
                    value={this.state.content}
                    onFocus={this.props.redlikeLightSoftware ? this.handleContentFocus : null}
                    onChange={this.handleContentChange}
                />
                {this.getAddFileSection()}
                {this.getLoader()}
            </React.Fragment>,
            "flex-row-gap-10px flex-column slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleSendButtonClick}
                    svgBefore={imgSend}
                    label={translate("helper.send")}
                    disabled={this.state.subject === "" || this.state.content === "" || this.props.blocked}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("helper.bugReport"))}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    width: "60%",
                    height: "70%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        blocked: store.navigation.blocked,
        license: store.license.uuid,
        pos: store.license.registrationData.pointOfSale,
        swVersion: store.module.softwareVersion,
        mainDbVersion: store.server.activeDatabase?.main?.version ?? null,
        localDbVersion: store.server.activeDatabase?.local?.version ?? null
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseBugReportModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.BUG_REPORT_MODAL));
        },
        dispatchSendErrorReportAction: (subject, content, filePaths) => {
            dispatch(helperActions.sendErrorReport(subject, content, filePaths));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(keyboardActions.setUniversalKeyboardState(state, selector));
        }
    };
};

export default BugReportModal = connect(mapStoreToProps, mapDispatchToProps)(BugReportModal);
